import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import PerfectScrollbar from "react-perfect-scrollbar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReadMoreAndLess from "react-read-more-less";
import Grid from "@mui/material/Grid";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Chip,
  Checkbox,
  IconButton,
} from "@mui/material";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import PermDeviceInformationTwoToneIcon from "@mui/icons-material/PermDeviceInformationTwoTone";

import Cisinformation from "../Cisinformation/Cisinformation";
import ActualValue from "../Cisinformation/ActualValue";

import IndividualForm from "../Userdata/IndividualForm";
import GroupForm from "../Userdata/GroupForm";
import OverallFrom from "../Userdata/OverallSelectedFrom";

import { FormatColorResetOutlined } from "@mui/icons-material";

function EnhancedTableHead() {
  return (
    <>
      <TableHead>
        <TableRow className="align-items-center table-flush css-serial">
          {window.localStorage.getItem("rollback_run_access") ===
          "You do not have permission to perform this action." ? (
            ""
          ) : (
            <React.Fragment>
              <TableCell width="5%" padding="checkbox"></TableCell>
            </React.Fragment>
          )}
          <TableCell width="5%" align="center">
            <h6>Cis_no</h6>
          </TableCell>
          <TableCell align="center">
            <h6>CIS_Topic</h6>
          </TableCell>
          <TableCell width="10%" align="center">
            <h6>Level</h6>
          </TableCell>
          {window.localStorage.getItem("rollback_run_access") ===
          "You do not have permission to perform this action." ? (
            ""
          ) : (
            <TableCell width="5%" align="center">
              <h6>Status</h6>
            </TableCell>
          )}
          <TableCell width="5%" align="center">
            <h6>Result</h6>
          </TableCell>
          <TableCell width="5%" align="center">
            <h6>Info</h6>
          </TableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

const EnhancedTableToolbar = (props) => {
  const { failedcount, customcolor, content, overallcount } = props;
  return (
    <React.Fragment>
      <a>
        <span style={{ color: customcolor }}>
          {content} Audits : {failedcount} / Overall Audits : {overallcount}
        </span>
      </a>
    </React.Fragment>
  );
};

export default function FailedTable(props) {
  const { CisResults, overallAudit, fixedAudit } = props;

  const [open, setOpen] = React.useState(false);
  const [getactualvalue, setGetactualvalue] = React.useState([]);

  const handleClickOpen = (event, actualvalue) => {
    setGetactualvalue([]);
    const auditID = window.sessionStorage.getItem("auditID");
    fetch(
      `${process.env.REACT_APP_API_URL}/api/auditactualvalue/${actualvalue}:${auditID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setGetactualvalue(resp))
      .catch((error) => {
        console.error(error);
      });
    sessionStorage.setItem("failed_fact", getactualvalue);
    setOpen(true);
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [dropdown, setdropdown] = React.useState([]);
  const [itemselected, setItemselected] = React.useState([]);
  const [itemgroupselected, setItemgroupselected] = React.useState([]);
  const [selectedall, setSelectedall] = React.useState(false);
  const [selectedgroup, setSelectedgroup] = React.useState({});

  const [headerselected, setHeaderselected] = React.useState([]);
  const [headeroverallselected, setHeaderoverallselected] =
    React.useState(false);

  const checkmoreinfo = (cis_no) => (e) => {
    e.preventDefault();
    var value;
    if (dropdown[cis_no]) {
      value = false;
    } else {
      value = true;
    }
    setdropdown((prevState) => ({ ...prevState, [cis_no]: value }));
  };

  const [newresult, setNewresult] = React.useState([]);
  const [selected, setSelected] = React.useState([]);
  React.useEffect(() => {
    setNewresult({ CisResults });
    if (CisResults) {
      CisResults.map((val) => {
        val.result.map((row) => {
          if (row.status === "FIXED") {
            setdropdown((prevState) => ({ ...prevState, [row.cis_no]: false }));
          }
        });
      });
    }
  }, [CisResults]);

  const [expandedheader, setExpandedheader] = React.useState({});

  const handleChangedropdown = (panel) => (event, isExpanded) => {
    setExpandedheader(isExpanded ? panel : false);
  };
  const isSelected = (cis_no) => selected.indexOf(cis_no) !== -1;
  const isGroupSelected = (cis_no) => itemgroupselected.indexOf(cis_no) !== -1;

  const [userdata, setUserdata] = React.useState([]);
  React.useEffect(() => {
    const auditID = window.sessionStorage.getItem("auditID");
    fetch(`${process.env.REACT_APP_API_URL}/api/hostUserdata/${auditID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setUserdata(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <ActualValue
        component="audit"
        open={open}
        setOpen={setOpen}
        getactualvalue={getactualvalue}
      />
      <Card>
        <CardHeader
          title={`Fixed (Fixed Audits : ${fixedAudit} / Overall Audits : ${overallAudit})`}
        />
        {newresult.CisResults ? (
          <React.Fragment>
            {CisResults.map((val, index) => {
              const isItemSelected1 = isSelected(val.header_id);
              const labelId = `select all desserts-${index}`;
              if (val.fixedCount > 0) {
                return (
                  <div>
                    <Accordion
                      defaultExpanded={expandedheader ? true : false}
                      onChange={handleChangedropdown(val.header_id)}
                      style={{ cursor: "pointer" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          <strong>{val.header_id}</strong> - {val.header_name}
                        </Typography>
                        <Typography sx={{ color: "text.secondary" }}>
                          (Fixed Audits : {val.fixedCount} / Overall Audits :{" "}
                          {val.overallCount})
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Card>
                          <Paper sx={{ width: "100%" }}>
                            <TableContainer
                              sx={{ maxHeight: 1100 }}
                              component={Paper}
                              style={{ borderColor: "#333" }}
                            >
                              <Table
                                aria-labelledby="tableTitle"
                                aria-label="enhanced table"
                              >
                                <TableHead className="bg-lightBlue-200">
                                  <TableRow className="align-items-center table-flush css-serial">
                                    <TableCell>Cis_no</TableCell>
                                    <TableCell>CIS_Topic</TableCell>
                                    <TableCell>Level</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Result</TableCell>
                                    <TableCell>Info</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {val.result.map((row, sindex) => {
                                    const isItemSelected = isSelected(
                                      row.cis_no
                                    );
                                    const labelId = `enhanced-table-checkbox-${sindex}`;
                                    if (row.status === "FIXED") {
                                      return (
                                        <React.Fragment>
                                          <TableRow>
                                            <TableCell
                                              align="center"
                                              component="th"
                                              id={labelId}
                                              scope="row"
                                              padding="none"
                                              width="5%"
                                            >
                                              {row.cis_no}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                textAlign: "left",
                                                whiteSpace: "normal",
                                                wordWrap: "break-word",
                                              }}
                                            >
                                              <ReadMoreAndLess
                                                className="read-more-content"
                                                charLimit={100}
                                                readMoreText="Read more"
                                                readLessText="Read less"
                                              >
                                                {row.cis_topic_name}
                                              </ReadMoreAndLess>
                                            </TableCell>
                                            <TableCell
                                              width="10%"
                                              style={{ textAlign: "left" }}
                                            >
                                              {row.level}
                                            </TableCell>
                                            <TableCell
                                              width="10%"
                                              style={{
                                                textAlignLast: "left",
                                              }}
                                            >
                                              <button
                                                disabled
                                                className="bg-emerald-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                                type="button"
                                              >
                                                FIXED
                                              </button>
                                            </TableCell>
                                            <TableCell
                                              width="5%"
                                              style={{
                                                textAlignLast: "center",
                                              }}
                                            >
                                              <IconButton
                                                color="primary"
                                                size="sm"
                                                title="Info"
                                                style={{
                                                  padding: "0px",
                                                  color: "lightgreen",
                                                }}
                                                onClick={(event) => {
                                                  handleClickOpen(
                                                    event,
                                                    row.fact_name
                                                  );
                                                }}
                                              >
                                                <PermDeviceInformationTwoToneIcon
                                                  fontSize="small"
                                                  color="primary"
                                                />
                                              </IconButton>
                                            </TableCell>
                                            <TableCell
                                              width="5%"
                                              align="center"
                                            >
                                              <IconButton
                                                color="primary"
                                                size="sm"
                                                title="Info"
                                                style={{
                                                  padding: "0px",
                                                  color: "lightgreen",
                                                }}
                                                onClick={checkmoreinfo(
                                                  row.cis_no
                                                )}
                                              >
                                                <InfoTwoToneIcon
                                                  fontSize="small"
                                                  color="lightgreen"
                                                />
                                              </IconButton>
                                            </TableCell>
                                          </TableRow>
                                          {dropdown[row.cis_no] ? (
                                            <TableRow
                                              id={"multiCollapse" + row.cis_no}
                                            >
                                              <Cisinformation
                                                OS={window.sessionStorage.getItem(
                                                  "OS"
                                                )}
                                                FactName={row.fact_name}
                                              />
                                            </TableRow>
                                          ) : (
                                            ""
                                          )}
                                        </React.Fragment>
                                      );
                                    }
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        </Card>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                );
              }
            })}
          </React.Fragment>
        ) : (
          <CardContent style={{ textAlign: "center" }}>
            <span>Loading ...</span>
          </CardContent>
        )}
        <br />
        <br />
      </Card>
    </>
  );
}